exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newSchoolOrgPage .schoolSection{vertical-align:top;display:inline-block;width:47%;margin-right:3%;margin-bottom:15px;border:1px solid #ccc;padding:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/appdev/crm/new_school_org_page.scss
// module id = 814
// module chunks = 0